import {
    Box,
    Button,
    Link,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    Typography,
} from '@mui/material'
import ImageCamera from '../../../assets/images/camera.png'
import ImageHeadset from '../../../assets/images/headset.png'
import ImageCar from '../../../assets/images/car.png'
import LikeButton from '../components/LikeButton'
import { ThanksProps } from '../types'
import HelpIcon from '@mui/icons-material/Help'
import TagManager from 'react-gtm-module'
import { useHelpText } from '../../../api/texts/hooks'

const ThanxView: React.FC<ThanksProps> = ({ interests, handleSetInterest }) => {
    const { data: thanksHeadingText } = useHelpText('USER_THANKS')

    const handleBackToZZ = () => {
        TagManager.dataLayer({
            dataLayer: {
                event: 'clickCustomerZone',
            },
        })
        if (process.env.REACT_APP_ZZ)
            window.location.href = process.env.REACT_APP_ZZ
    }
    return (
        <Box className='max-w-2xl mx-auto mt-14'>
            <Paper className='text-center p-6 rounded-md shadow-lg'>
                <Box p={1}>
                    <Typography variant='h4'>DĚKUJEME ZA VYPLNĚNÍ!</Typography>
                </Box>
                <Box p={1}>
                    {thanksHeadingText && (
                        <Typography
                            dangerouslySetInnerHTML={{
                                __html: thanksHeadingText,
                            }}
                        ></Typography>
                    )}
                </Box>
                <Box p={1}>
                    <List>
                        <ListItem
                            secondaryAction={
                                <Link
                                    target='_blank'
                                    href='https://www.bezpecnostnicentrum.cz/cs/videosluzby'
                                >
                                    <HelpIcon></HelpIcon>
                                </Link>
                            }
                        >
                            <ListItemIcon>
                                <img
                                    src={ImageCamera}
                                    alt='Camera'
                                ></img>
                            </ListItemIcon>
                            <ListItemText>Videoslužby</ListItemText>
                            <LikeButton
                                isRegistered={interests.videoServicesInterest}
                                onClick={() => {
                                    TagManager.dataLayer({
                                        dataLayer: {
                                            event: 'clickVideo',
                                        },
                                    })
                                    handleSetInterest('videoServicesInterest')
                                }}
                            />
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <Link
                                    target='_blank'
                                    href='https://www.bezpecnostnicentrum.cz/cs/audiovyzva'
                                >
                                    <HelpIcon></HelpIcon>
                                </Link>
                            }
                        >
                            <ListItemIcon>
                                <img
                                    src={ImageHeadset}
                                    alt='Headset'
                                ></img>
                            </ListItemIcon>
                            <ListItemText>Audioslužby</ListItemText>
                            <LikeButton
                                isRegistered={interests.audioServicesInterest}
                                onClick={() => {
                                    TagManager.dataLayer({
                                        dataLayer: {
                                            event: 'clickAudio',
                                        },
                                    })
                                    handleSetInterest('audioServicesInterest')
                                }}
                            />
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <Link
                                    target='_blank'
                                    href='https://www.bezpecnostnicentrum.cz/cs/strezeni-vozidel'
                                >
                                    <HelpIcon></HelpIcon>
                                </Link>
                            }
                        >
                            <ListItemIcon>
                                <img
                                    src={ImageCar}
                                    alt='Car'
                                ></img>
                            </ListItemIcon>
                            <ListItemText>Střežení vozidel</ListItemText>
                            <LikeButton
                                isRegistered={interests.carSecurityInterest}
                                onClick={() => {
                                    TagManager.dataLayer({
                                        dataLayer: {
                                            event: 'clickCar',
                                        },
                                    })
                                    handleSetInterest('carSecurityInterest')
                                }}
                            />
                        </ListItem>
                        {/* <ListItem
                                secondaryAction={
                                    <Link target='_blank' href='https://www.jablotronsos.cz/'>
                                        <HelpIcon></HelpIcon>
                                    </Link>
                                }
                            >
                                <ListItemIcon>
                                    <img src={ImagePerson} alt='Car'></img>
                                </ListItemIcon>
                                <ListItemText className={classes.listItemText}>Osobní bezpečnost</ListItemText>
                                <LikeButton
                                    isRegistered={interests.personSecurityInterest}
                                    onClick={() => {
                                        TagManager.dataLayer({
                                            dataLayer: {
                                                'event': 'clickPersonal',
                                            }
                                        });
                                        handleSetInterest('personSecurityInterest')
                                    }}
                                />
                            </ListItem> */}
                    </List>
                </Box>
                <Box p={1}>
                    <Button
                        variant='contained'
                        color='primary'
                        size='large'
                        className='normal-case py-3 pl-6 rounded-md text-pantone-gray-2 text-2xl leading-[1.4375rem] shadow-none'
                        onClick={() => handleBackToZZ()}
                    >
                        Zpět do zákaznické zóny
                    </Button>
                </Box>
            </Paper>
        </Box>
    )
}

export default ThanxView
